import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import I18n from "../../i18n";

type DocumentTitleProps = { title: string | undefined };

export const DocumentTitle: React.FC<DocumentTitleProps> = ({
  title,
  children,
}) => (
  <Fragment>
    <Helmet>
      <title>{title ? `${title} | ${I18n.title}` : I18n.title}</title>
    </Helmet>
    {children}
  </Fragment>
);
